import { createService } from '@bonanza-social/toolkit/api';
import { AccountMarketingSchema } from './accountService.schema';

export default createService(
  {
    getAccountMarketing: {
      method: 'GET',
      url: '/?expand=marketingPreferences',
      responseSchema: AccountMarketingSchema,
    },
  },
  ({ userId }) => `/Accounts/${userId}`,
);
